import { Container } from '@react-email/components';
import { merge } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Node } from 'slate';

const richText = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        const { t } = useTranslation();
        const stringContent = Node.string(element);
        const firstType = element.children[0].type;

        const placholderTypeMap = {
            'heading-one': 'h1',
            'heading-two': 'h2',
            'heading-three': 'h3',
            'heading-four': 'h4',
        };

        const Placeholder = placholderTypeMap?.[firstType] || 'p';
        const placeholderText =
            Placeholder === 'p' ? t('Start typing...') : t('Heading');

        const textCursorStyle = { style: { cursor: 'text' } };

        const containerStyle = {
            style: {
                maxWidth: '100%',
                position: 'relative',
            },
        };

        return (
            <Container
                {...attributes}
                {...merge(
                    textCursorStyle,
                    element.containerAttributes,
                    containerStyle,
                )}
            >
                {children}
                {!stringContent && (
                    <Placeholder
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            ...element.containerAttributes.style,
                            pointerEvents: 'none',
                            userSelect: 'none',
                            opacity: 0.5,
                        }}
                    >
                        {placeholderText}
                    </Placeholder>
                )}
            </Container>
        );
    },
    PreviewElement: ({ node, children }) => {
        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };
        return (
            <Container {...merge({}, node.containerAttributes, containerStyle)}>
                {children}
            </Container>
        );
    },
};

export default richText;
